export default __webpack_public_path__ + "static/media/test.6da4cfa4.txt";